export default {
  root: ({ props }) => ({
    class: [
      {
        'opacity-60 select-none pointer-events-none cursor-default':
          props.disabled,
      },
    ],
  }),
  button: ({ context }) => ({
    class: [
      'relative',
      // Font
      'leading-[normal]',

      // Flex Alignment
      'inline-flex items-center align-bottom text-center',

      // Spacing
      'px-4 py-[0.625rem]',

      'shadow-sm',

      // Shape
      'border border-r-0 border-surface-200 dark:border-surface-700',
      'first:rounded-l-md first:rounded-tr-none first:rounded-br-none',
      'last:border-r last:rounded-tl-none last:rounded-bl-none last:rounded-r-md',

      // Color
      'text-surface-700 dark:text-white/80',
      {
        'bg-white dark:bg-surface-900': !context.active,
        'bg-surface-100 dark:bg-surface-400': context.active,
      },

      // States
      'focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-400/50 dark:focus:ring-primary-300/50',
      {
        'hover:bg-surface-50 dark:hover:bg-surface-800/80': !context.active,
        'hover:bg-surface-200 dark:hover:bg-surface-300': context.active,
      },
      {
        'opacity-60 select-none pointer-events-none cursor-default':
          context.disabled,
      },
      // Transition
      'transition duration-200',

      // Misc
      'cursor-pointer select-none overflow-hidden',
    ],
  }),
  label: {
    class: 'font-semibold text-sm leading-[normal]',
  },
}
